import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDragicon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 6,
	height: 10,
	viewBox: "0 0 6 10",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M2 5C2 4.44772 1.55228 4 1 4C0.447715 4 0 4.44772 0 5C0 5.55228 0.447715 6 1 6C1.55228 6 2 5.55228 2 5Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M2.06287 1C2.06287 0.447715 1.61515 0 1.06287 0C0.510581 0 0.0628662 0.447715 0.0628662 1C0.0628662 1.55228 0.510581 2 1.06287 2C1.61515 2 2.06287 1.55228 2.06287 1Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6 5C6 4.44772 5.55228 4 5 4C4.44772 4 4 4.44772 4 5C4 5.55228 4.44772 6 5 6C5.55228 6 6 5.55228 6 5Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6 1C6 0.447715 5.55228 0 5 0C4.44772 0 4 0.447715 4 1C4 1.55228 4.44772 2 5 2C5.55228 2 6 1.55228 6 1Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M2.06299 9C2.06299 8.44772 1.61527 8 1.06299 8C0.510704 8 0.0629883 8.44772 0.0629883 9C0.0629883 9.55228 0.510704 10 1.06299 10C1.61527 10 2.06299 9.55228 2.06299 9Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6 9C6 8.44772 5.55228 8 5 8C4.44772 8 4 8.44772 4 9C4 9.55228 4.44772 10 5 10C5.55228 10 6 9.55228 6 9Z",
			fill: "currentColor"
		})
	]
});
export default SvgDragicon;
